import FavoriteHeartButton from "@app-contexts/user/features/favorite-events/components/FavoriteHeartButton/FavoriteHeartButton.web";
import Box from "@ui-kit/layout/Box/Box.web";
import CDNImage from "@ui-kit/media/CDNImage/CDNImage.web";
import { CardImageProps } from "./CardImage.props";

const CardImage = ({
  src,
  alt,
  width,
  height,
  title = undefined,
  ariaLabel = undefined,
  sizes = undefined,
  favoriteData = undefined,
  useServerlessResize = undefined, // Leave it to CDNImage.tsx to set the default prop value.
  aspectRatio = undefined,
  borderRadius = "0px",
  imageStyle = undefined,
  containerStyle = undefined,
}: CardImageProps) => {
  let imageAspectRatio = aspectRatio;
  if (width && height && !aspectRatio) {
    imageAspectRatio = `${width}/${height}`;
  }
  return (
    <Box
      width="100%"
      height="100%"
      position="relative"
      borderRadius={borderRadius}
      overflow="hidden"
      style={{
        ...containerStyle,
        aspectRatio: imageAspectRatio,
      }}
    >
      {/* CardImage MUST be wrapped in UserSessionAuthStateProvider to display FavoriteHeartButton */}
      {favoriteData && <FavoriteHeartButton favoriteData={favoriteData} />}
      <CDNImage
        src={src}
        alt={alt}
        title={title}
        aria-label={ariaLabel}
        responsive
        width={width}
        height={height}
        sizes={sizes}
        useServerlessResize={useServerlessResize}
        style={imageStyle}
      />
    </Box>
  );
};

export default CardImage;
